import { connect } from "react-redux";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import momentPropTypes from "react-moment-proptypes";
import FloatingActionButton from "material-ui/FloatingActionButton";
import ActionCode from "material-ui/svg-icons/action/code";
import PostalOperatorSelectionSidebarContainer from "../../target-node-impc-selector/containers/PostalOperatorSelectionSidebarContainer";
import ProgressButtons from "./ProgressButtons";
import {
  getArrivalCheckedMailProcessingCenters,
  getArrivalPostalOperators,
  getDepartureCheckedMailProcessingCenters,
  getDeparturePostalOperators,
  getExpandedArrivalPostalOperators,
  getExpandedDeparturePostalOperators,
  getSelectedArrivalPostalOperators,
  getSelectedDeparturePostalOperators,
  getDirections,
  getIsDirectionsSwitched,
  getTrafficCheckedOperator,
  getTrafficOperatorNodes,
  getDeparturePostalOperatorIsLoading,
  getArrivalPostalOperatorIsLoading,
} from "../../target-node-impc-selector/redux/selectors/PostalOperatorSelectors";
import SaveIMPCSelectionModal from "../../target-node-impc-selector/components/SaveIMPCSelectionModal";
import { saveUserIMPCSelectionRequestActionCreator } from "../../../user/redux/actions/UserActions";
import PostalOperatorSelector from "../../target-node-impc-selector/components/PostalOperatorSelector";
import {
  getPeriodSelectorEndDate,
  getPeriodSelectorStartDate,
} from "../../period-selector/redux/selectors/PeriodSelectionSelectors";
import {
  departureMailProcessingCenterCheckedActionCreator,
  onDeparturePostalOperatorExpanded,
  onDeSelectAllDepartureMailProcessingCenters,
  onSelectAllDepartureMailProcessingCenters,
  retrieveOutboundPostalOperatorsRequestActionCreator,
} from "../../target-node-impc-selector/redux/actions/DeparturePostalOperatorActions";
import {
  arrivalMailProcessingCenterCheckedActionCreator,
  onArrivalPostalOperatorExpanded,
  onDeSelectAllArrivalMailProcessingCenters,
  onSelectAllArrivalMailProcessingCenters,
  retrieveInboundPostalOperatorsRequestActionCreator,
} from "../../target-node-impc-selector/redux/actions/ArrivalPostalOperatorActions";
import {
  setDirections,
  setDirectionFlag,
  switchDepartureArrival,
} from "../../target-node-impc-selector/redux/actions/PostalOperatorActions";
import {
  onDeSelectAllTrafficOperators,
  onSelectAllTrafficOperators,
  trafficOperatorsCheckedActionCreator,
} from "../../target-node-impc-selector/redux/actions/TrafficOperatorActions";
import OperatorTypes from "../../../common/redux/actions/types/OperatorTypes";
import * as LocationTypes from "../../../common/redux/actions/types/LocationTypes";
import sc from "../../../common/redux/actions/types/SelectionCriteriaTypes";
import scDefinitions from "../../../common/config/SelectionCriteriaDefinitions";
import DirectionTypes from "../../../common/redux/actions/types/DirectionTypes";
import noop from "../../../../core/modules/common/tools/noop";
import { createPresetSelectionsOnSave } from "../../../react-table/helpers/utils";
import CheckboxTreeSelector from "../../../common/components/CheckboxTreeSelector";
import filterIMPCCodesIfExistsInPostalOperators from "../../target-node-impc-selector/redux/filters/filterIMPCCodesIfExistsInPostalOperators";

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      retrieveOutboundPostalOperatorsRequestActionCreator,
      retrieveInboundPostalOperatorsRequestActionCreator,
      saveUserIMPCSelectionRequestActionCreator,
      departureMailProcessingCenterCheckedActionCreator,
      onDeparturePostalOperatorExpanded,
      onSelectAllDepartureMailProcessingCenters,
      onDeSelectAllDepartureMailProcessingCenters,
      arrivalMailProcessingCenterCheckedActionCreator,
      onArrivalPostalOperatorExpanded,
      onSelectAllArrivalMailProcessingCenters,
      onDeSelectAllArrivalMailProcessingCenters,
      setDirections,
      switchDepartureArrival,
      getIsDirectionsSwitched,
      setDirectionFlag,
      trafficOperatorsCheckedActionCreator,
      onSelectAllTrafficOperators,
      onDeSelectAllTrafficOperators,
    },
    dispatch
  );

const mapStateToProps = (state) => ({
  selectedDeparturePostalOperatorsNodes:
    getSelectedDeparturePostalOperators(state),
  departurePostalOperatorsNodes: getDeparturePostalOperators(state),
  departureCheckedMailProcessingCenters:
    getDepartureCheckedMailProcessingCenters(state),
  departureExpandedPostalOperators: getExpandedDeparturePostalOperators(state),
  departureIsLoading: getDeparturePostalOperatorIsLoading(state),
  selectedArrivalPostalOperatorsNodes: getSelectedArrivalPostalOperators(state),
  arrivalPostalOperatorsNodes: getArrivalPostalOperators(state),
  arrivalCheckedMailProcessingCenters:
    getArrivalCheckedMailProcessingCenters(state),
  arrivalIsLoading: getArrivalPostalOperatorIsLoading(state),
  arrivalExpandedPostalOperators: getExpandedArrivalPostalOperators(state),
  startDate: getPeriodSelectorStartDate(state),
  endDate: getPeriodSelectorEndDate(state),
  directions: getDirections(state),
  isDirectionsSwitched: getIsDirectionsSwitched(state),
  trafficOperatorsNodes: getTrafficOperatorNodes(state),
  trafficCheckedOperators: getTrafficCheckedOperator(state),
});

// eslint-disable-next-line react/prefer-stateless-function
class TargetNodeImpcWizardContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstDeparture: true,
      firstArrival: true,
      departureSelectionTreeLoaded: false,
      arrivalSelectionTreeLoaded: false,
      showOnlySelectedDeparturePostalOperators: false,
      showOnlySelectedArrivalPostalOperators: false,
      showSaveSelectionModal: false,
      saveSelectionCheckedMailProcessingCenters: [],
      saveSelectionSelections: [],
      directionDepartureDisabled: true,
      directionArrivalDisabled: true,
    };
  }

  componentDidMount() {
    this.props.setDirections({
      directions: this.props.children.report.reportDirections,
    });

    if (!this.props.departureIsLoading) {
      this.props.retrieveOutboundPostalOperatorsRequestActionCreator(
        {
          defaultDirection: this.getDefaultDirection(),
          startDate: this.props.startDate,
          endDate: this.props.endDate,
        },
        this.props.children.report,
        this.props.departureCheckedMailProcessingCenters
      );
    }

    if (this.hasArrivalSelection() && !this.props.arrivalIsLoading) {
      this.props.retrieveInboundPostalOperatorsRequestActionCreator(
        {
          defaultDirection: this.getDefaultDirection(),
          startDate: this.props.startDate,
          endDate: this.props.endDate,
        },
        this.props.children.report,
        this.props.arrivalCheckedMailProcessingCenters
      );
    }
  }

  async UNSAFE_componentWillReceiveProps(nextProps) {
    await this.props.selectedDeparturePostalOperatorsNodes;

    // eslint-disable-next-line max-len
    if (
      this.state.firstDeparture &&
      this.props.departurePostalOperatorsNodes ===
        nextProps.departurePostalOperatorsNodes &&
      nextProps.selectedDeparturePostalOperatorsNodes.length !== 0
    ) {
      this.setState({
        firstDeparture: false,
        showOnlySelectedDeparturePostalOperators: true,
      });
    }

    await this.props.selectedArrivalPostalOperatorsNodes;
    // eslint-disable-next-line max-len
    if (
      this.state.firstArrival &&
      this.props.arrivalPostalOperatorsNodes ===
        nextProps.arrivalPostalOperatorsNodes &&
      nextProps.selectedArrivalPostalOperatorsNodes.length !== 0
    ) {
      this.setState({
        firstArrival: false,
        showOnlySelectedArrivalPostalOperators: true,
      });
    }

    await this.props.departurePostalOperatorsNodes;
    this.setState({
      departureSelectionTreeLoaded:
        this.props.departurePostalOperatorsNodes.length > 0,
    });

    await this.props.arrivalPostalOperatorsNodes;
    this.setState({
      arrivalSelectionTreeLoaded:
        this.props.arrivalPostalOperatorsNodes.length > 0,
    });
  }

  componentDidUpdate(prevProps) {
    // Existing UI logic
    if (
      this.props.arrivalCheckedMailProcessingCenters !==
        prevProps.arrivalCheckedMailProcessingCenters &&
      this.props.arrivalCheckedMailProcessingCenters.length === 0
    ) {
      this.setState({
        showOnlySelectedArrivalPostalOperators: false,
      });
    }
    if (
      this.props.departureCheckedMailProcessingCenters !==
        prevProps.departureCheckedMailProcessingCenters &&
      this.props.departureCheckedMailProcessingCenters.length === 0
    ) {
      this.setState({
        showOnlySelectedDeparturePostalOperators: false,
      });
    }
    if (
      this.props.departurePostalOperatorsNodes !==
      prevProps.departurePostalOperatorsNodes
    ) {
      this.setState({
        directionDepartureDisabled: false,
      });
    }
    if (
      this.props.arrivalPostalOperatorsNodes !==
      prevProps.arrivalPostalOperatorsNodes
    ) {
      this.setState({
        directionArrivalDisabled: false,
      });
    }

    // Refetch when dates change
    const datesChanged = (
      !this.props.startDate.isSame(prevProps.startDate, 'day') ||
      !this.props.endDate.isSame(prevProps.endDate, 'day')
    );

    if (datesChanged) {
      console.log('[IMPC] componentDidUpdate - dates changed, refetching');
      console.log('[IMPC] Old dates:', prevProps.startDate.format('YYYY-MM-DD'), prevProps.endDate.format('YYYY-MM-DD'));
      console.log('[IMPC] New dates:', this.props.startDate.format('YYYY-MM-DD'), this.props.endDate.format('YYYY-MM-DD'));

      this.props.retrieveOutboundPostalOperatorsRequestActionCreator(
        {
          defaultDirection: this.getDefaultDirection(),
          startDate: this.props.startDate,
          endDate: this.props.endDate,
        },
        this.props.children.report,
        this.props.departureCheckedMailProcessingCenters
      );

      if (this.hasArrivalSelection()) {
        this.props.retrieveInboundPostalOperatorsRequestActionCreator(
          {
            defaultDirection: this.getDefaultDirection(),
            startDate: this.props.startDate,
            endDate: this.props.endDate,
          },
          this.props.children.report,
          this.props.arrivalCheckedMailProcessingCenters
        );
      }
    }
  }

  onSelectAllDeparturePostalOperators = () => {
    this.props.onSelectAllDepartureMailProcessingCenters(
      this.props.departurePostalOperatorsNodes
    );
  };

  onSelectAllArrivalPostalOperators = () => {
    this.props.onSelectAllArrivalMailProcessingCenters(
      this.props.arrivalPostalOperatorsNodes
    );
  };

  onDeSelectAllDeparturePostalOperators = () => {
    this.setState({
      showOnlySelectedDeparturePostalOperators: false,
    });
    this.props.onDeSelectAllDepartureMailProcessingCenters();
  };

  onDeSelectAllArrivalPostalOperators = () => {
    this.setState({
      showOnlySelectedArrivalPostalOperators: false,
    });
    this.props.onDeSelectAllArrivalMailProcessingCenters();
  };

  onSelectDeparturePostalOperatorOrImpc = (selected) => {
    if (selected.length === 0) {
      this.setState({
        showOnlySelectedDeparturePostalOperators: false,
      });
    } else {
      this.setState({
        firstDeparture: false,
      });
    }
    this.props.departureMailProcessingCenterCheckedActionCreator(
      selected,
      this.props.children.report
    );
  };

  onSelectArrivalPostalOperatorOrImpc = (selected) => {
    if (selected.length === 0) {
      this.setState({
        showOnlySelectedArrivalPostalOperators: false,
      });
    } else {
      this.setState({
        firstArrival: false,
      });
    }
    this.props.arrivalMailProcessingCenterCheckedActionCreator(
      selected,
      this.props.children.report
    );
  };

  onExpandDeparturePostalOperator = (expanded) => {
    this.props.onDeparturePostalOperatorExpanded(expanded);
  };

  onExpandArrivalPostalOperator = (expanded) => {
    this.props.onArrivalPostalOperatorExpanded(expanded);
  };

  onToggleShowOnlySelectedDeparturePostalOperators = () => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      showOnlySelectedDeparturePostalOperators:
        !this.state.showOnlySelectedDeparturePostalOperators,
    });
  };

  onToggleShowOnlySelectedArrivalPostalOperators = () => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      showOnlySelectedArrivalPostalOperators:
        !this.state.showOnlySelectedArrivalPostalOperators,
    });
  };

  onSwitchInboundOutbound = () => {
    this.props.setDirectionFlag({
      switched: !this.props.isDirectionsSwitched,
    });
    this.props.switchDepartureArrival({
      departure: {
        checkedMailProcessingCenters: filterIMPCCodesIfExistsInPostalOperators(
          this.props.departureCheckedMailProcessingCenters,
          this.props.departurePostalOperatorsNodes,
          this.props.children.report
        ),
        expandedPostalOperators: this.props.departureExpandedPostalOperators,
        nodes: this.props.departurePostalOperatorsNodes,
      },
      arrival: {
        checkedMailProcessingCenters: filterIMPCCodesIfExistsInPostalOperators(
          this.props.arrivalCheckedMailProcessingCenters,
          this.props.arrivalPostalOperatorsNodes,
          this.props.children.report
        ),
        expandedPostalOperators: this.props.arrivalExpandedPostalOperators,
        nodes: this.props.arrivalPostalOperatorsNodes,
      },
    });
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      showOnlySelectedDeparturePostalOperators:
        this.state.showOnlySelectedArrivalPostalOperators,
      // eslint-disable-next-line react/no-access-state-in-setstate
      showOnlySelectedArrivalPostalOperators:
        this.state.showOnlySelectedDeparturePostalOperators,
    });
  };

  getScCode = () => {
    const selectionCriteria =
      this.props.children.report.selectionCriteria.items;
    let scCode = sc.SC010;
    if (selectionCriteria.indexOf(sc.SC011) > -1) {
      scCode = sc.SC011;
    } else if (selectionCriteria.indexOf(sc.SC010_OVERVIEW) > -1) {
      scCode = sc.SC010_OVERVIEW;
    } else if (selectionCriteria.indexOf(sc.SC011NA) > -1) {
      scCode = sc.SC011NA;
    }
    return scCode;
  };

  getDefaultDirection() {
    let defaultDirection = this.props.children.report.reportDirections[0];
    if (this.props.isDirectionsSwitched) {
      defaultDirection =
        defaultDirection === DirectionTypes.INBOUND
          ? DirectionTypes.OUTBOUND
          : DirectionTypes.INBOUND;
    }
    return defaultDirection;
  }

  hasArrivalSelection = () => this.getScCode() !== sc.SC011NA;

  hasTrafficSelection = () => this.getScCode() === sc.SC010_OVERVIEW;

  openSaveSelectionModalForDeparture = () => {
    this.openSaveSelectionModal({
      checkedMailProcessingCenters: createPresetSelectionsOnSave(
        this.props.departureCheckedMailProcessingCenters,
        this.props.departurePostalOperatorsNodes
      ),
      selections: this.props.departureSelections,
    });
  };

  openSaveSelectionModalForArrival = () => {
    this.openSaveSelectionModal({
      checkedMailProcessingCenters: createPresetSelectionsOnSave(
        this.props.arrivalCheckedMailProcessingCenters,
        this.props.arrivalPostalOperatorsNodes
      ),
      selections: this.props.arrivalSelections,
    });
  };

  openSaveSelectionModal = ({ checkedMailProcessingCenters, selections }) => {
    this.setState({
      showSaveSelectionModal: true,
      saveSelectionCheckedMailProcessingCenters: checkedMailProcessingCenters,
      saveSelectionSelections: selections,
    });
  };

  closeSaveSelectionModal = () => {
    this.setState({
      showSaveSelectionModal: false,
    });
  };

  saveSelection = ({ name, checkedMailProcessingCenters }) => {
    this.props.saveUserIMPCSelectionRequestActionCreator(
      name,
      checkedMailProcessingCenters
    );
    this.closeSaveSelectionModal();
  };

  onSelectTrafficOperators = (selected) => {
    this.props.trafficOperatorsCheckedActionCreator(selected);
  };

  onDeselectAllTrafficOperators = () => {
    this.props.onDeSelectAllTrafficOperators();
  };

  onSelectAllTrafficOperators = () => {
    this.props.onSelectAllTrafficOperators(this.props.trafficOperatorsNodes);
  };

  render() {
    const tempDepartureNodes = [
      {
        value: "DUMMY",
        label: "LOADING...",
        expandDisabled: true,
        children:
          this.props.departureCheckedMailProcessingCenters &&
          this.props.departureCheckedMailProcessingCenters.length > 0
            ? this.props.departureCheckedMailProcessingCenters.map(
                (initialItem) => ({ value: initialItem, label: "" })
              )
            : [],
      },
    ];
    const tempArrivalNodes = [
      {
        value: "DUMMY",
        label: "LOADING...",
        expandDisabled: true,
        children:
          this.props.arrivalCheckedMailProcessingCenters &&
          this.props.arrivalCheckedMailProcessingCenters.length > 0
            ? this.props.arrivalCheckedMailProcessingCenters.map(
                (initialItem) => ({ value: initialItem, label: "" })
              )
            : [],
      },
    ];

    const departurePostalOperatorSelectorProps = {
      selected: this.props.departureCheckedMailProcessingCenters,
      expanded: !this.state.departureSelectionTreeLoaded
        ? []
        : this.props.departureExpandedPostalOperators,
      expandDisabled: !this.state.departureSelectionTreeLoaded
        ? true
        : this.props.children.report.locationType === LocationTypes.OPERATOR,
      isShowOnlySelected: !this.state.departureSelectionTreeLoaded
        ? true
        : this.state.showOnlySelectedDeparturePostalOperators,
      // eslint-disable-next-line no-nested-ternary
      postalOperatorNodes: !this.state.departureSelectionTreeLoaded
        ? tempDepartureNodes
        : this.state.showOnlySelectedDeparturePostalOperators
        ? this.props.selectedDeparturePostalOperatorsNodes
        : this.props.departurePostalOperatorsNodes,
      originalPostalOperatorNodes: !this.state.departureSelectionTreeLoaded
        ? tempDepartureNodes
        : this.props.departurePostalOperatorsNodes,
      onSelect: !this.state.departureSelectionTreeLoaded
        ? noop
        : this.onSelectDeparturePostalOperatorOrImpc,
      onExpand: !this.state.departureSelectionTreeLoaded
        ? noop
        : this.onExpandDeparturePostalOperator,
      onSelectAll: !this.state.departureSelectionTreeLoaded
        ? noop
        : this.onSelectAllDeparturePostalOperators,
      onDeSelectAll: !this.state.departureSelectionTreeLoaded
        ? noop
        : this.onDeSelectAllDeparturePostalOperators,
      onShowOnlySelected: !this.state.departureSelectionTreeLoaded
        ? noop
        : this.onToggleShowOnlySelectedDeparturePostalOperators,
      openSaveSelectionModal: !this.state.departureSelectionTreeLoaded
        ? noop
        : this.openSaveSelectionModalForDeparture,
    };

    const arrivalPostalOperatorSelectorProps = {
      selected: this.props.arrivalCheckedMailProcessingCenters,
      expanded: !this.state.arrivalSelectionTreeLoaded
        ? []
        : this.props.arrivalExpandedPostalOperators,
      expandDisabled: !this.state.arrivalSelectionTreeLoaded
        ? true
        : this.props.children.report.locationType === LocationTypes.OPERATOR,
      isShowOnlySelected: !this.state.arrivalSelectionTreeLoaded
        ? true
        : this.state.showOnlySelectedArrivalPostalOperators,
      // eslint-disable-next-line no-nested-ternary
      postalOperatorNodes: !this.state.arrivalSelectionTreeLoaded
        ? tempArrivalNodes
        : this.state.showOnlySelectedArrivalPostalOperators
        ? this.props.selectedArrivalPostalOperatorsNodes
        : this.props.arrivalPostalOperatorsNodes,
      originalPostalOperatorNodes: !this.state.arrivalSelectionTreeLoaded
        ? tempArrivalNodes
        : this.props.arrivalPostalOperatorsNodes,
      onSelect: !this.state.arrivalSelectionTreeLoaded
        ? noop
        : this.onSelectArrivalPostalOperatorOrImpc,
      onExpand: !this.state.arrivalSelectionTreeLoaded
        ? noop
        : this.onExpandArrivalPostalOperator,
      onSelectAll: !this.state.arrivalSelectionTreeLoaded
        ? noop
        : this.onSelectAllArrivalPostalOperators,
      onDeSelectAll: !this.state.arrivalSelectionTreeLoaded
        ? noop
        : this.onDeSelectAllArrivalPostalOperators,
      onShowOnlySelected: !this.state.arrivalSelectionTreeLoaded
        ? noop
        : this.onToggleShowOnlySelectedArrivalPostalOperators,
      openSaveSelectionModal: !this.state.arrivalSelectionTreeLoaded
        ? noop
        : this.openSaveSelectionModalForArrival,
    };

    const trafficOperators = {
      selected: this.props.trafficCheckedOperators,
      nodes: this.props.trafficOperatorsNodes,
      onSelect: this.onSelectTrafficOperators,
      onSelectAll: this.onSelectAllTrafficOperators,
      onDeSelectAll: this.onDeselectAllTrafficOperators,
      expandDisabled: true,
      isShowOnlySelected: false,
      originalNodes: [],
    };

    const selectionCriteria =
      this.props.children.report.selectionCriteria.items;
    const SC_CODE = this.getScCode();
    const nextSelectionCriteriaRouteName = (
      scDefinitions[
        selectionCriteria[selectionCriteria.indexOf(SC_CODE) + 1]
      ] || {}
    ).routeName;

    const hasArrival = this.hasArrivalSelection();
    const hasTraffic = this.hasTrafficSelection();

    let layoutClass = "single-section-layout";
    if (hasArrival && hasTraffic) {
      layoutClass = "three-section-layout";
    } else if (hasArrival) {
      layoutClass = "two-section-layout";
    } else if (hasTraffic) {
      layoutClass = "traffic-departure-layout";
    }

    /* eslint-disable react/jsx-indent */
    return (
      <div className="operator-selector-wrapper">
        {this.state.showSaveSelectionModal && (
          <SaveIMPCSelectionModal
            saveSelection={this.saveSelection}
            closeModal={this.closeSaveSelectionModal}
            checkedMailProcessingCenters={
              this.state.saveSelectionCheckedMailProcessingCenters
            }
            selections={this.state.saveSelectionSelections}
          />
        )}
        <div className="operator-sidebar">
          <PostalOperatorSelectionSidebarContainer
            operatorType={OperatorTypes.DEPARTURE}
            operators={
              departurePostalOperatorSelectorProps.originalPostalOperatorNodes
            }
            report={this.props.children.report}
          />
        </div>

        <div className="operators">
          <div className={`operators-selection-panel ${layoutClass}`}>
            {this.hasTrafficSelection() && (
              <div className="operator traffic-section">
                <div className="operator-selector-container">
                  <CheckboxTreeSelector title="TRAFFIC" {...trafficOperators} />
                </div>
              </div>
            )}

            <div className="operator">
              <PostalOperatorSelector
                title="DEPARTURE OPERATOR"
                {...departurePostalOperatorSelectorProps}
              />
            </div>
            {this.props.directions.directionSwitchEnabled &&
              this.hasArrivalSelection() && (
                <div className="operator-divider">
                  <FloatingActionButton
                    onClick={this.onSwitchInboundOutbound}
                    backgroundColor="#03adaa"
                    mini
                    disabled={
                      this.state.directionDepartureDisabled ||
                      this.state.directionArrivalDisabled
                    }
                    style={{
                      zIndex: 1,
                      marginLeft: "-20px",
                      marginTop: "11px",
                      border: "5px solid #abe1e5",
                      boxShadow: "none",
                    }}
                  >
                    <ActionCode />
                  </FloatingActionButton>
                </div>
              )}
            {this.hasArrivalSelection() && (
              <div className="operator">
                <PostalOperatorSelector
                  title="ARRIVAL OPERATOR"
                  {...arrivalPostalOperatorSelectorProps}
                />
              </div>
            )}
          </div>

          <div className="actions">
            <ProgressButtons
              next={this.props.children.routes[nextSelectionCriteriaRouteName]}
            />
          </div>
        </div>

        {this.hasArrivalSelection() && (
          <div className="operator-sidebar">
            <PostalOperatorSelectionSidebarContainer
              operatorType={OperatorTypes.ARRIVAL}
              operators={
                arrivalPostalOperatorSelectorProps.originalPostalOperatorNodes
              }
              report={this.props.children.report}
            />
          </div>
        )}
      </div>
    );
  }
}

TargetNodeImpcWizardContainer.propTypes = {
  report: PropTypes.shape({
    selectionCriteria: PropTypes.objectOf(PropTypes.shape),
    reportDirections: PropTypes.arrayOf(PropTypes.string),
    locationType: PropTypes.string,
  }),
  routes: PropTypes.objectOf(PropTypes.shape).isRequired,
  retrieveOutboundPostalOperatorsRequestActionCreator: PropTypes.func,
  retrieveInboundPostalOperatorsRequestActionCreator: PropTypes.func,
  selectedDeparturePostalOperatorsNodes: PropTypes.arrayOf(PropTypes.object),
  departurePostalOperatorsNodes: PropTypes.arrayOf(PropTypes.object),
  departureCheckedMailProcessingCenters: PropTypes.arrayOf(PropTypes.string),
  departureExpandedPostalOperators: PropTypes.arrayOf(PropTypes.string),
  departureSelections: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      impcCodes: PropTypes.arrayOf(PropTypes.string).isRequired,
    })
  ),
  selectedArrivalPostalOperatorsNodes: PropTypes.arrayOf(PropTypes.object),
  arrivalPostalOperatorsNodes: PropTypes.arrayOf(PropTypes.object),
  arrivalCheckedMailProcessingCenters: PropTypes.arrayOf(PropTypes.string),
  arrivalExpandedPostalOperators: PropTypes.arrayOf(PropTypes.string),
  arrivalSelections: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      impcCodes: PropTypes.arrayOf(PropTypes.string).isRequired,
    })
  ),
  saveUserIMPCSelectionRequestActionCreator: PropTypes.func,
  departureMailProcessingCenterCheckedActionCreator: PropTypes.func,
  onDeparturePostalOperatorExpanded: PropTypes.func,
  onSelectAllDepartureMailProcessingCenters: PropTypes.func,
  onDeSelectAllDepartureMailProcessingCenters: PropTypes.func,
  arrivalMailProcessingCenterCheckedActionCreator: PropTypes.func,
  onArrivalPostalOperatorExpanded: PropTypes.func,
  onSelectAllArrivalMailProcessingCenters: PropTypes.func,
  onDeSelectAllArrivalMailProcessingCenters: PropTypes.func,
  directions: PropTypes.shape({
    defaultDirection: PropTypes.string,
    directionSwitchEnabled: PropTypes.bool,
    switched: PropTypes.bool,
  }),
  setDirections: PropTypes.func,
  isDirectionsSwitched: PropTypes.bool,
  switchDepartureArrival: PropTypes.func,
  setDirectionFlag: PropTypes.func,
  trafficOperatorsNodes: PropTypes.arrayOf(PropTypes.object),
  trafficCheckedOperators: PropTypes.arrayOf(PropTypes.string),
  trafficOperatorsCheckedActionCreator: PropTypes.func,
  onSelectAllTrafficOperators: PropTypes.func,
  onDeSelectAllTrafficOperators: PropTypes.func,
  startDate: momentPropTypes.momentObj,
  endDate: momentPropTypes.momentObj,
};

export const ConnectedTargetNodeImpcWizardContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TargetNodeImpcWizardContainer);

export default ConnectedTargetNodeImpcWizardContainer;
